export const STATUS_ACTIVE = "Active";
export const STATUS_INACTIVE = "Inactive";

export const ACTION_TYPE_EDIT = "edit";
export const ACTION_TYPE_VIEW = "view";

export const NUMBER_PATTERN = /^([-]?[1-9][0-9]*|0)$/g;

export const NO_SPACE_PATTERN = /^\S+(\s+\S+)*$/;
